import React from 'react';
import cn from 'classnames';
import { Navigation, NavigationProps as BaseNavigationProps } from '@economic/gaudi';
import './style.css';

export const Page = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <div {...props} className={cn('bg-grey-light flex-grow flex overflow-hidden', props.className)} />
);

const PageNavigation = (props: BaseNavigationProps) => {
    const { children, ...otherProps } = props;

    return (
        <div {...otherProps} id="navigation" className={cn('w-64 z-10 flex-shrink-0', props.className)}>
            <Navigation className="h-full border-r-2 border-grey-light">{children}</Navigation>
        </div>
    );
};

interface ContentProps extends React.HTMLAttributes<HTMLDivElement> {
    inset?: boolean;
}

const Content = ({ inset = true, ...props }: ContentProps) => (
    <div className="bg-white flex-shrink flex-grow overflow-y-auto">
        <div {...props} className={cn({ 'p-4': inset }, props.className)} />
    </div>
);

Page.Navigation = PageNavigation;
Page.Content = Content;
